'use client'

import { PartnerProductCard } from '@src/quince-components/src'

// Styles

import { FEATURES, MODULES } from '@src/quince-site-common/src/constants/template-info'
import useCaptureDataException from '@src/quince-site-common/src/hooks/useCaptureDataException'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import useDynamicStyle from '@src/quince-site-common/src/hooks/useDynamicStyle'
import { SectionProps } from '@src/SectionRenderer/SectionRenderer.types'
import classnames from 'classnames'
import { useEffect, useState } from 'react'

import styles from './flatPartnerProductList.module.scss'

// @i18n-ignore
const FLAT_PARTNER_PRODUCT_LIST_CUSTOM_SECTION = 'flat-partner-product-list-custom-section'

function FlatPartnerProductList({
  sectionConfig: {
    partnerProducts = [],
    title,
    classNames = [],
    classNamesMobileOverrides = [],
    baseDynamicClasses = [],
    mobileDynamicClassesOverrides = [],
    tracker,
  },
}: SectionProps) {
  const deviceInfo = useDeviceInfo()
  const isDesktop = deviceInfo.deviceType === DEVICE_TYPES.DESKTOP
  const [_, setProductShowLimit] = useState(8)
  // const buttonRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    setProductShowLimit(isDesktop ? 8 : 4)
  }, [isDesktop])

  const { className, styleObject } = useDynamicStyle({
    mobileClassNamesOverride: classNamesMobileOverrides,
    baseClassNames: classNames,
    baseDynamicValueClasses: baseDynamicClasses,
    dynamicValueClassesMobileOverride: mobileDynamicClassesOverrides,
    wrapperClassName: styles.dynamic_class_wrapper,
    postFix: FLAT_PARTNER_PRODUCT_LIST_CUSTOM_SECTION,
  })

  //TODO: commented the below code as show more feature is not needed on MVP
  // const onShowMoreClick = () => {
  //   isDesktop
  //     ? setProductShowLimit(prevState => prevState + 4)
  //     : setProductShowLimit(prevState => prevState + 2);
  //   scrollToRef(buttonRef);
  // };

  const isPartnerProductEmpty = !partnerProducts.length

  useCaptureDataException({
    captureException: isPartnerProductEmpty,
    // @i18n-ignore
    errorMsg: 'No partner product is present',
    // @i18n-ignore
    name: 'Partner product check',
    module: MODULES.PARTNER_PRODUCT_LIST,
    feature: FEATURES.GET_PRODUCT,
  })

  return (
    <div className={classnames(styles.flatProductListContainer, className)} style={styleObject}>
      <div id={title?.toLowerCase()} className={styles.wrapper}>
        {partnerProducts.map((partnerProduct, idx) => {
          //if (idx >= productShowLimit) return null;
          return (
            <PartnerProductCard
              className={styles.productCard}
              key={partnerProduct.contentfulPartnerProductId}
              product={partnerProduct}
              tracker={tracker}
            />
          )
        })}
      </div>
      {/* TODO: commented the below code as show more feature is not needed on MVP */}
      {/* {partnerProducts.length > productShowLimit && (
          <div ref={buttonRef}>
            <Button
              className={styles.showMoreBtn}
              type={BUTTON_TYPES.SECONDARY}
              size={BUTTON_SIZE.MEDIUM}
              round={true}
              onClick={onShowMoreClick}
            >
              Show More
            </Button>
          </div>
         )} */}
    </div>
  )
}

export default FlatPartnerProductList
